<!--
  挂件 MetalPendant
-->
<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 金属挂件" name="金属挂件">
        <el-row>
          <el-col :span="24" class="my-middle">
            <el-checkbox
              v-bind:key="select.id"
              v-for="select in metalPendant"
              v-model="select.status"
              v-bind:label="select.name"
              style="width:150px;margin:10px"
              border
            ></el-checkbox>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-collapse v-model="forcollapse" wtfname="metalPendantFormActive">
              <DrippingMetalPendant v-if="metalPendant[0].status"/>
              <BakingFinishMetalPendant v-if="metalPendant[1].status"/>
              <EnamelMetalPendant v-if="metalPendant[2].status"/>
              <BadgeMetalPendant v-if="metalPendant[3].status"/>
            </el-collapse>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
import DrippingMetalPendant from "./MetalPendant/DrippingMetalPendant.vue";
import BakingFinishMetalPendant from "./MetalPendant/BakingFinishMetalPendant.vue";
import EnamelMetalPendant from "./MetalPendant/EnamelMetalPendant.vue";
import BadgeMetalPendant from "./MetalPendant/BadgeMetalPendant.vue";

export default {
  name: "MetalPendant",
  methods: {},
  components: {
    DrippingMetalPendant,
    BakingFinishMetalPendant,
    EnamelMetalPendant,
    BadgeMetalPendant
  },
  data() {
    return {
      forcollapse: ['滴胶工艺','滴胶烤漆','珐琅挂件','金属徽章'],
      metalPendant: [
        { id: "DrippingMetalPendant", name: "滴胶挂件", status: false },
        { id: "BakingFinishMetalPendant", name: "滴胶烤漆挂件", status: false },
        { id: "EnamelMetalPendant", name: "珐琅挂件", status: false },
        { id: "BadgeMetalPendant", name: "金属徽章", status: false }
      ],
      metalPendantFormActive: []
    };
  }
};
</script>
<style scoped>
</style>
